import MarketingNav from '../marketing-nav/MarketingNav'
import MarketingFooter from '../marketing-footer/MarketingFooter'
import type { MarketingShellProps } from './types'
import { Main, Shell } from './styled'

const MarketingShell = ({ children }: MarketingShellProps): JSX.Element => (
  <Shell>
    <MarketingNav />
    <Main>{children}</Main>
    <MarketingFooter />
  </Shell>
)

export default MarketingShell
